import React from 'react';

const Logo = () => {
    return (
        /*<img src="./img/logo.png" alt="Logo Stramy Transfer" className='Logo' />*/
        <span>FREDHO</span>
    );
};

export default Logo;